export const tableWidth = {
    data () {
        return {
            footerColumns: [],
            pageWidth: 0
        }
    },
    created () {
        window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy: function () {
        window.removeEventListener('resize', this.handleResize)
    },
    mounted () {
        this.handleResize()
    },
    methods: {
        handleResize (event) {
            this.pageWidth = document.getElementById('page-top').offsetWidth
            // if (this.pageWidth < 1520) {
            //     this.columns.map((item, index) => {
            //         if (item.defaultWidth) {
            //             item.width = item.defaultWidth
            //             this.columns.splice(index, 1, item)
            //         }
            //     })
            // } else {
            //     this.columns.map((item, index) => {
            //         if (item.defaultWidth) {
            //             item.width = this.pageWidth * (item.defaultWidth / 1520)
            //             this.columns.splice(index, 1, item)
            //         }
            //     })
            // }
            this.columns.map((item, index) => {
                if (item.defaultWidth) {
                    item.width = this.pageWidth * (item.defaultWidth / 1520)
                    this.columns.splice(index, 1, item)
                }
            })
        },
    }
}
